module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-operations"
  }, [(_vm.item) ? _c('cards', {
    attrs: {
      "data": _vm.cardData
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row columns"
  }, [_c('label', [_vm._v("Select where the reservations will be moved"), (_vm.options) ? _c('selectize', {
    ref: "selectize",
    attrs: {
      "options": _vm.options,
      "optionTemplate": _vm.optionTemplate,
      "renderTemplate": _vm.optionTemplate,
      "valueField": "id"
    },
    on: {
      "itemAdded": _vm.updateVehicleSlots,
      "itemRemoved": _vm.updateVehicleSlots
    }
  }) : _vm._e()], 1), _c('button', {
    staticClass: "button",
    class: {
      disabled: !_vm.vehicle_slots_id
    },
    attrs: {
      "disabled": !_vm.vehicle_slots_id
    },
    on: {
      "click": _vm.drain
    }
  }, [_vm._v("Drain vehicle slot")])]), (_vm.results) ? _c('div', {
    staticClass: "row columns"
  }, [_c('accordion', [_c('accordion-item', {
    attrs: {
      "title": "Migrated"
    }
  }, _vm._l((_vm.results.migrated), function(reservation) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('h2', [_vm._v("Old Reservation")]), _c('reservation', {
      attrs: {
        "item": reservation.old,
        "type": "shortList"
      }
    })], 1), _c('div', {
      staticClass: "column"
    }, [_c('h2', [_vm._v("New Reservation")]), _c('reservation', {
      attrs: {
        "item": reservation.new,
        "type": "shortList"
      }
    })], 1)])
  }), 0), _c('accordion-item', {
    attrs: {
      "title": "Stalled"
    }
  }, _vm._l((_vm.results.stalled), function(reservation) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('h2', [_vm._v("Stalled")]), _c('reservation', {
      attrs: {
        "item": reservation,
        "type": "shortList"
      }
    })], 1)])
  }), 0)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-116c64f1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Operations.vue
// module id = 2264
// module chunks = 1